import { object, string } from 'yup';

function noDuplicateNamesSchema(names: string[]) {
  return string()
    .required('Name is required')
    .test('not existing name', 'Name is already in use', (newName) =>
      names.every((name) => name !== newName)
    );
}

export function validationSchema(names: string[], isEditing = false) {
  return object().shape({
    name: noDuplicateNamesSchema(names),
    credentials: object()
      .shape({
        username: string().required('Username is required.'),
        personalAccessToken: isEditing
          ? string().notRequired()
          : string().required('Personal Access Token is required'),
      })
      .required(),
  });
}
